import PropTypes from 'prop-types';
import DatePicker from '../../../../juristec-ui/core/DatePicker';

const DateInput = ({
  label, state, handle,
}) => (
  <>
    <h5 className={state.error ? 'field-error-label' : ''}>
      {label}
    </h5>
    <DatePicker
      label=""
      value={state.value}
      onChange={handle}
      readOnly={false}
      dateFormat="dd/MM/yyyy"
      atModal
    />
    {state.errorMsg.length > 0 && (
      <span className="field-error-msg">
        {state.errorMsg}
      </span>
    )}
  </>
);

DateInput.propTypes = {
  label: PropTypes.string.isRequired,
  state: PropTypes.shape({
    value: PropTypes.instanceOf(Date),
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
  }).isRequired,
  handle: PropTypes.func.isRequired,
};

export default DateInput;
